import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { useState } from "react";
import Layout from './components/layout.jsx';
import MainPage from './pages/main_page.jsx';
import About from './pages/about.jsx';
import Career from './pages/career.jsx';
import Collaboration from './pages/collaboration.jsx';
import IntroScreen from './components/introScreen.jsx';
import Services from './pages/services.jsx';
import './App.css';

function App() {
  const [showIntro, setShowIntro] = useState(true);
  return (
    <Router>
    {showIntro && <IntroScreen onFinish={() => setShowIntro(false)} />}

      <Layout >
      <Routes>
        <Route path="/" element={<MainPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/career" element={<Career />} />
        <Route path="/collaboration" element={<Collaboration />} />
        <Route path="/services" element={<Services />} />
      </Routes>
    </Layout>
    </Router>
  );
}

export default App;
